import React from 'react';

const DestinationContext = React.createContext({});

export const DestinationProvider = DestinationContext.Provider;

export default DestinationContext;
